/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import { HotTable } from '@handsontable/react';
import 'handsontable/dist/handsontable.min.css';
import {
  AGREE_DISAGREE_COL,
  AUDIT_SHEET_HEADER,
  AUDIT_SHEET_KEY,
  BATCH_AGREE_DISAGREE_COL,
  BATCH_AUDIT_SHEET_HEADER,
  BATCH_RESPONSE_AS_COL,
  NUMERIC_KEYS,
  RENDERING_AS_COL,
  RESPONSE_AS_COL,
} from '../constants';
import { registerAllModules } from 'handsontable/registry';
import Handsontable from 'handsontable';
import '../styles.css';
import { useBoolean } from '@chakra-ui/react';
import { useContext } from 'react';
import { AuditSheetContext } from '../../../providers/AuditSheetProvider';
import { useToastr } from '@laxmimanogna/code-quick-components';
import { getRowColArray } from '../getRowColumn';
import AppColors from '../../../constants/AppColors';
import { registerCustomCells } from './hands_on_table_renderers/CustomRenderers';
import { format } from 'date-fns';
import { toTitleCase } from '../../../utils/common.utils';
import { useLocation, useSearchParams } from 'react-router-dom';
import {
  findAgreeDisAgreeColumn,
  findDollorColumn,
  findHighlightedColumn,
  findResponseColumn,
  getAuditSheetKeys,
  handleAgreeDisagree,
  updateICDAudit,
  // prepareAuditSheetColumn,
} from '../../../utils/auditsheet.utils';
import { defaultColNames } from '../../../constants/constants';
import { prepareAuditSheetHeader } from '../../../utils/prepareSheetHeader.utils';
import { prepareAuditSheetColumn } from '../../../utils/prepareAuditsheetColumns.utils';
import { decodeResponseValue, generateOptions, MultiSelectEditor } from '../../../utils/responseColumn';

// Register the editor
Handsontable.editors.registerEditor('multi-select', MultiSelectEditor);

function getScaledRowHeight(scale) {
  return `${24 * scale}px`;
}

function getScaledHeaderFontSize(scale) {
  return 13 * scale + 'px';
}

function getScaledRowFontSize(scale) {
  return 14 * scale + 'px';
}

const AuditSheet = ({
  scale = 1,
  sheet,
  view,
  updateAuditSheet,
  updateSheet,
  onCommentClick,
  onSelectionEnd,
  closeComment,
  batch,
  batchId,
  uploadId,
  height,
  setSheets,
  rowFilter = null
}) => {
  const location = useLocation();

  let agreeValidator = (value, callback) => {
    setTimeout(() => {
      if (value.toLowerCase() === 'yes' || value === '-') {
        callback(true);
      } else {
        callback(false);
      }
    }, 1000);
  };

  const [queryParameters] = useSearchParams(location.search);
  const rowLocation = queryParameters.get('location');
  registerCustomCells({});

  // contexts
  const auditSheetContext = useContext(AuditSheetContext);
  const { industryCodes, iCDCodes, modifiers, getComments, commentFlags, providerOptions, responseAuditIssues } =
    auditSheetContext;

  const {
    setAuditSheetColumnsKeys,
    setHilightedColumn,
    setDollorColumn,
    setAgreeDisAgreeCol,
  } = auditSheetContext;

  const {
    agreeDisAgreeCol,
    auditSheetColumnsKeys,
    dollarColumn,
    highlightedColumn,
  } = auditSheetContext;

  // booleans
  const [isProviderDollarDisabled, ipddState] = useBoolean(false);
  const [isAuditedDollarDisabled, iaddState] = useBoolean(false);

  const [sheetData, setSheetData] = useState([]);
  const [columnData, setColumnData] = useState([]);
  const [auditSheetHeaders, setAuditSheetHeaders] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [tempColData, setTempColData] = useState([]);
  // refs
  const hotRef = useRef(null);
  const responseAuditIssuesRef = useRef(responseAuditIssues);
  const [localHeader, setLocalHeader] = useState(auditSheetHeaders);
  const [localColumnData, setLocalColumnData] = useState(columnData);
  const [responseColumn, setResponseColumn] = useState(null);

  const toast = useToastr();

  registerAllModules();
  
  Handsontable.renderers.registerRenderer(
    'customStylesRendererCheckbox',
    (hotInstance, TD, row, column, prop, value, cellProperties) => {
      Handsontable.renderers.getRenderer('checkbox')(hotInstance, TD, row, column, prop, value, cellProperties);
      TD.style.fontSize = getScaledRowFontSize(scale);
      TD.style.textAlign = 'center';
    }
  );

  Handsontable.renderers.registerRenderer(
    'customStylesRenderer',
    (hotInstance, TD, ...rest) => {
      Handsontable.renderers.getRenderer('text')(hotInstance, TD, ...rest);
      TD.style.fontSize = getScaledRowFontSize(scale);
      TD.style.textAlign = 'center';
    }
  );
  Handsontable.renderers.registerRenderer(
    'agreeRenderer',
    (hotInstance, TD, row, column, prop, value, cellProperties) => {
      Handsontable.renderers.getRenderer('text')(
        hotInstance,
        TD,
        row,
        column,
        prop,
        value,
        cellProperties
      );
      TD.style.fontSize = getScaledRowFontSize(scale);
      TD.style.textAlign = 'center';
      if (value != null) {
        TD.innerHTML = value === true || value === 'true' ? 'Yes' : '-';
      }
    }
  );

  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  const [windowSize, setWindowSize] = useState(getWindowSize().innerWidth);

  useEffect(() => {
    function handleWindowResize() {
      const size = getWindowSize();
      setWindowSize(size.innerWidth);
    }
    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  useEffect(() => {
    const hot = hotRef.current.hotInstance;
    if (
      Object.keys(auditSheetContext.selectedCell).length &&
      sheet.data.length
    ) {
      const { row, col } = auditSheetContext.selectedCell;
      const index = sheet.data.findIndex(d => d.id === row);
      if (index !== -1) {
        hot.selectCell(index, col);
      }
    } else {
      hot.deselectCell();
    }
  }, [auditSheetContext.selectedCell]);

  // Force Handsontable to re-apply cell properties when comment flags change
  useEffect(() => {
    if (hotRef.current?.hotInstance) {
      hotRef.current.hotInstance.render();
    }
  }, [commentFlags]);

  const [highlightIndex, setHighlightIndex] = useState(-1);

  useEffect(() => {
    const hot = hotRef.current.hotInstance;
    if (rowLocation && sheet.data.length) {
      const index = sheetData.findIndex(d => d.row_id === Number(rowLocation));
      setHighlightIndex(index);
      if (index !== -1) {
        hot.scrollViewportTo(Number(index), 0);
      }
    }
  }, [rowLocation, sheetData]);

  React.useEffect(() => {
    setColumnData(localColumnData);
    setAuditSheetHeaders(localHeader);
  }, [localHeader, localColumnData]);

  React.useEffect(() => {
    if (columnData.length) {
      const emptyColumns = [];

      columnData.forEach((cd, i) => {
        const isEmptyColumn = hotRef.current?.hotInstance?.isEmptyCol(i);
        const columnName = cd?.data;
        if (isEmptyColumn && !defaultColNames.includes(columnName)) {
          emptyColumns.push(i);
        }
      });

      const _tempColData = columnData.filter(
        (_, index) => !emptyColumns.includes(index)
      );

      setTempColData(_tempColData);

      setHiddenColumns([...emptyColumns]);
    }
  }, [columnData]);

  useEffect(() => {
    if (hiddenColumns.length) {
      const emptyColumns = [];
      const emptyColumnNames = [];

      columnData.forEach((cd, i) => {
        const isEmptyColumn = hotRef.current?.hotInstance?.isEmptyCol(i);
        const columnName = cd?.data;
        if (isEmptyColumn && !defaultColNames.includes(columnName)) {
          emptyColumns.push(i);
          emptyColumnNames.push(columnName);
        }
      });

      const tempColumnData = columnData.filter(
        (col, i) => !emptyColumnNames.includes(col.data)
      );
      const tempColumnHeader = auditSheetHeaders.filter(
        (header, i) => !emptyColumns.includes(i)
      );

      setLocalHeader(tempColumnHeader);
      setLocalColumnData(tempColumnData);
      const _sheetData=sheet.data
    
      const updatedRes = _sheetData.map(item => {
        const updatedItem = { ...item };
        emptyColumnNames.forEach(key => {
          if (key in updatedItem) {
            delete updatedItem[key];
          }
        });
        return updatedItem;
      });

      setSheets([{
        index: 1,
        sheet_name: 'Sheet1',
        data:updatedRes
      }])

    }
  }, [hiddenColumns]);

  useEffect(() => {
    responseAuditIssuesRef.current = responseAuditIssues;
    if (responseAuditIssues?.length && hotRef.current?.hotInstance) {
      hotRef.current.hotInstance.render();
    }
  }, [responseAuditIssues]);

  React.useEffect(() => {
    const _hilghtedColumn = findHighlightedColumn(columnData);
    const _dollorColumn = findDollorColumn(columnData);
    const _auditSheetkey = getAuditSheetKeys(columnData);
    const _agreeDisagree = findAgreeDisAgreeColumn(columnData);
    const _responseColumn = findResponseColumn(columnData);

    setResponseColumn(_responseColumn);
    setAuditSheetColumnsKeys([..._auditSheetkey]);
    setHilightedColumn([..._hilghtedColumn]);
    setDollorColumn([..._dollorColumn]);
    setAgreeDisAgreeCol([..._agreeDisagree]);
  }, [columnData.length]);

  const _columnData = [
    {
      data: 'missing_info',
      type: 'checkbox',
      width: windowSize * 0.03,
      renderer: 'customStylesRendererCheckbox',
      readOnly: view,
    },
    {
      data: 'encounter_no',
      type: 'numeric',
      width: windowSize * 0.07,
      alignment: 'center',
      renderer: 'customStylesRenderer',
      readOnly: view,
    },
    {
      data: 'rendering',
      type: 'audit_sheet.dropdown_renderer',
      width: windowSize * 0.07,
      source: providerOptions.map(p => p.value),
      readOnly: view,
    },
    {
      data: 'enc_dt',
      type: 'date',
      dateFormat: 'MM-DD-YYYY',
      width: windowSize * 0.07,
      renderer: 'customStylesRenderer',
      readOnly: view,
    },
    {
      data: 'srvcs_no',
      type: 'text',
      width: windowSize * 0.07,
      renderer: 'hoverCPTRenderer',
      readOnly: view,
    },
    {
      data: 'provider_rvu',
      type: 'numeric',
      width: windowSize * 0.07,
      renderer: 'customStylesRenderer',
      readOnly: view,
    },
    {
      data: 'provider_dollar_value',
      type: 'audit_sheet.currency_renderer',
      width: windowSize * 0.07,
      readOnly: view || isProviderDollarDisabled,
    },
    {
      data: 'response',
      type: 'text',
      width: windowSize * 0.15,
      renderer: 'customStylesRenderer',
      readOnly: view,
    },
    {
      data: 'agree',
      type: 'text',
      validator: agreeValidator,
      width: windowSize * 0.07,
      renderer: 'agreeRenderer',
      readOnly: view,
    },
    {
      data: 'disagree',
      type: 'text',
      validator: agreeValidator,
      width: windowSize * 0.07,
      renderer: 'agreeRenderer',
      readOnly: view,
    },
    {
      data: 'audited_code',
      type: 'text',
      width: windowSize * 0.07,
      renderer: 'hoverCPTRenderer',
      readOnly: view,
    },
    {
      data: 'audited_rvu',
      type: 'numeric',
      width: windowSize * 0.07,
      renderer: 'customStylesRenderer',
      readOnly: view,
    },
    {
      data: 'audited_dollar_value',
      type: 'audit_sheet.currency_renderer',
      width: windowSize * 0.07,
      readOnly: view || isAuditedDollarDisabled,
    },
    {
      data: 'notes',
      type: 'text',
      width: windowSize * 0.15,
      renderer: 'customStylesRenderer',
      readOnly: view,
    },
  ];

  React.useEffect(() => {
    const reDestructuredData = sheet.data;

    // spreading in object
    const _reDestructuredData = reDestructuredData.map(sd => {
      const tempObj = { ...sd, ...sd?.additional_attributes };

      delete tempObj.additional_attributes;

      return tempObj;
    });

    // -- preparing dynamic column headers --
    const auditSheetColumnsheaders =
      prepareAuditSheetHeader(_reDestructuredData);
    setAuditSheetHeaders(auditSheetColumnsheaders);

    // dynamic columns
    const dynamicColumnData = prepareAuditSheetColumn(
      _reDestructuredData,
      windowSize,
      view,
      providerOptions,
      isAuditedDollarDisabled,
      isProviderDollarDisabled
    );

    const responseColumnIndex = dynamicColumnData.findIndex(
      col => col.data === 'response'
    );

    if (responseColumnIndex !== -1) {
      dynamicColumnData[responseColumnIndex].source = function () {
        const rowData = this.instance.getSourceDataAtRow(this.row);
        return generateOptions(rowData, responseAuditIssuesRef.current);
      };

      dynamicColumnData[responseColumnIndex].renderer = function (
        instance,
        td,
        row,
        col,
        prop,
        value,
        cellProperties
      ) {
        Handsontable.renderers.TextRenderer.apply(this, [instance, td, row, col, prop, value, cellProperties]);
        const rowData = instance.getSourceDataAtRow(row);
        td.innerText = decodeResponseValue(value, rowData, responseAuditIssuesRef.current) || '';
        Object.assign(td.style, { textAlign: 'center', verticalAlign: 'middle' });
        return td;
      };
    }

    if (!!dynamicColumnData.length) {
      setColumnData(dynamicColumnData);
    } else {
      setColumnData(_columnData);
    }
  }, [sheet, responseAuditIssues]);

  function setLocalSheetData(data) {
    if (!data) {
      setSheetData([]);
    }
    const nextSheetData = [];
    for (let i = 0; i < data.length; i++) {
      const datum = data[i];

      const renderingValue = datum.rendering;
      if (renderingValue) {
        if (
          typeof renderingValue === 'object' &&
          Object.keys(renderingValue).length
        ) {
          datum.rendering = toTitleCase(
            `${renderingValue.first_name} ${renderingValue.last_name}`
          );
        } else {
          const providerOption = providerOptions.find(
            p => p.id === renderingValue
          );
          if (providerOption) {
            datum.rendering = providerOption.value;
          }
        }

        // if the rowfilter is not satisfied don't show them in the output auditsheet
        if (rowFilter && !rowFilter(datum)) {
          continue;
        }
      }
      if (datum.enc_dt) {
        const d = Date.parse(datum.enc_dt);
        if (d) {
          datum.enc_dt = format(new Date(d), 'MM-dd-yyyy');
        }
      }
      nextSheetData.push(datum);
    }
    setSheetData(nextSheetData);
  }

  useEffect(() => {
    registerCustomCells({ scale });
  }, [scale]);

  useEffect(() => {
    if (sheet.data) {
      setLocalSheetData(sheet.data);
    }
  }, [sheet.data, rowFilter, responseAuditIssues]);

  const updateSheetData = (nextSheetData, row, rowIndex) => {
    if (rowIndex != null) {
      nextSheetData[rowIndex] = {
        ...nextSheetData[rowIndex],
        ...row,
      };
    } else {
      nextSheetData.push(row);
    }

    return nextSheetData;
  };

  const onBeforeHotChange = change => {
    let nextSheetData = [...sheetData];
    change.map(changes => {
      const isNewRow = changes[0] > sheetData.length;
      switch (changes[1]) {
        case 'srvcs_no':
          if (
            Object.keys(industryCodes).length &&
            Object.keys(industryCodes).includes(changes[3])
          ) {
            const row = {
              [changes[1]]: changes[3],
              provider_dollar_value: industryCodes[changes[3]],
            };

            nextSheetData = updateSheetData(
              nextSheetData,
              row,
              isNewRow ? null : changes[0]
            );
            ipddState.on();
          } else {
            toast.showError({
              description: 'This Srvcs value is not available.',
            });
            const row = {
              srvcs_no: null,
              provider_dollar_value: null,
            };
            nextSheetData = updateSheetData(
              nextSheetData,
              row,
              isNewRow ? null : changes[0]
            );
          }
          break;
        case 'audited_code':
          if (
            Object.keys(industryCodes).length &&
            Object.keys(industryCodes).includes(changes[3])
          ) {
            const row = {
              [changes[1]]: changes[3],
              audited_dollar_value: industryCodes[changes[3]],
            };
            nextSheetData = updateSheetData(
              nextSheetData,
              row,
              isNewRow ? null : changes[0]
            );
            iaddState.on();
          } else {
            toast.showError({
              description: 'This Audited Code is not available.',
            });
            const row = {
              audited_code: null,
              audited_dollar_value: null,
            };
            nextSheetData = updateSheetData(
              nextSheetData,
              row,
              isNewRow ? null : changes[0]
            );
          }
          break;
        case 'agree':
          const row = {
            ...nextSheetData[changes[0]],
            [changes[1]]:
              changes[3] === ''
                ? null
                : changes[3].toLowerCase() === 'yes' ||
                  changes[3].toLowerCase() === 'true'
                ? true
                : false,
            disagree:
              changes[3] === ''
                ? null
                : changes[3].toLowerCase() === 'yes' ||
                  changes[3].toLowerCase() === 'true'
                ? false
                : true,
          };
          nextSheetData = updateSheetData(
            nextSheetData,
            row,
            isNewRow ? null : changes[0]
          );
          if (
            changes[3].toLowerCase() === 'yes' ||
            changes[3].toLowerCase() === 'true'
          ) {
            nextSheetData[changes[0]].audited_code =
              nextSheetData[changes[0]].srvcs_no;
            nextSheetData[changes[0]].audited_rvu =
              nextSheetData[changes[0]].provider_rvu;
            nextSheetData[changes[0]].audited_dollar_value =
              nextSheetData[changes[0]].provider_dollar_value;
          }
          break;
        case 'disagree':
          const disagreeRow = {
            [changes[1]]:
              changes[3] === ''
                ? null
                : changes[3].toLowerCase() === 'yes' ||
                  changes[3].toLowerCase() === 'true'
                ? true
                : false,
            agree:
              changes[3] === ''
                ? null
                : changes[3].toLowerCase() === 'yes' ||
                  changes[3].toLowerCase() === 'true'
                ? false
                : true,
          };
          nextSheetData = updateSheetData(
            nextSheetData,
            disagreeRow,
            isNewRow ? null : changes[0]
          );
          break;
        case 'response': {
          const newValue = changes[3];
          const responseRow = { response: newValue };
          nextSheetData = updateSheetData(nextSheetData, responseRow, isNewRow ? null : changes[0]);
          break;
        }
        case 'icd_agree':
        case 'icd_disagree':
          let editRow = handleAgreeDisagree(nextSheetData, changes);
          nextSheetData = updateSheetData(
            nextSheetData,
            editRow,
            isNewRow ? null : changes[0]
          );
          nextSheetData = updateICDAudit(nextSheetData, changes, editRow);
          break;
        case 'enc_dt':
          let data = changes[3];
          if (data) {
            const d = Date.parse(data);
            if (d) {
              const encDtRow1 = {
                [changes[1]]: format(new Date(d), 'MM-dd-yyyy'),
              };
              nextSheetData = updateSheetData(
                nextSheetData,
                encDtRow1,
                isNewRow ? null : changes[0]
              );
            } else {
              toast.showError({ description: 'Please, enter a valid date' });
            }
          } else {
            const encDtRow1 = {
              [changes[1]]: null,
            };
            nextSheetData = updateSheetData(
              nextSheetData,
              encDtRow1,
              isNewRow ? null : changes[0]
            );
          }

          break;
        default:
          const defaultRow = {
            [changes[1]]: changes[3],
          };
          nextSheetData = updateSheetData(
            nextSheetData,
            defaultRow,
            isNewRow ? null : changes[0]
          );
          break;
      }
    });
    setLocalSheetData(nextSheetData);
    //update audit sheet on first cell update in a row
    if (change.some(d => !sheetData[d[0]].id)) {
      updateAuditSheet({ ...sheet, data: nextSheetData });
    } else {
      updateSheet(nextSheetData);
    }
    return false;
  };

  function columnHighlight(
    instance,
    td,
    row,
    col,
    prop,
    value,
    cellProperties
  ) {
    Handsontable.renderers.TextRenderer.apply(this, arguments);
    td.style.background = AppColors.lightPink;
    td.style.fontSize = getScaledRowFontSize(scale);
    td.style.textAlign = 'center';
  }

  function rowHighlight(
    instance,
    td,
    row,
    col,
    prop,
    value,
    cellProperties
  ) {
    let baseRenderer = Handsontable.renderers.TextRenderer;

    if (cellProperties.type === 'checkbox') {
      baseRenderer = Handsontable.renderers.CheckboxRenderer;
    }
    baseRenderer(instance, td, row, col, prop, value, cellProperties);

    if (col === responseColumn) {
      const rowData = instance.getSourceDataAtRow(row);
      td.innerText = decodeResponseValue(value, rowData, responseAuditIssuesRef.current) || '';
    }

    td.style.backgroundColor = "#ffeeba";
    td.style.fontSize = getScaledRowFontSize(scale);
    td.style.textAlign = 'center';
  }


  const headerData = batch ? BATCH_AUDIT_SHEET_HEADER : AUDIT_SHEET_HEADER;

  const hotSettings = {
    data: sheet?.data,
    height,
    colHeaders: (localHeader && localHeader.length > 0) 
      ? localHeader.map((header, i) => {
          const fontSize = getScaledHeaderFontSize(scale);
          return `<div style="font-size: ${fontSize};"class="header">${header}</div>`;
        })
      : (auditSheetHeaders && auditSheetHeaders.length > 0)
        ? auditSheetHeaders.map((header, i) => {
            const fontSize = getScaledHeaderFontSize(scale);
            return `<div style="font-size: ${fontSize};"class="header">${header}</div>`;
          })
        : false,
    licenseKey: 'non-commercial-and-evaluation',
    autoWrapRow: true,
    contextMenu: {
      async callback(key, selection, clickEvent) {
        if (key !== 'rebuttals') return;
        onCommentClick(
          selection,
          { pageX: clickEvent.pageX || clickEvent.clientX, pageY: clickEvent.pageY || clickEvent.clientY },
          true,
          true,
          columnData,
          hotRef.current?.hotInstance.getSelected()[0]
        );
        const { row, uploadIds } = getRowColArray(selection[0], { ...sheet, data: sheetData }, batch);
        await getComments({ batchId, uploadId: uploadId || uploadIds[0], row });
      },
      items: {
        row_above: {
          name: () => '<p>Insert row above</p>',
          disabled() {
            return view;
          },
        },
        row_below: {
          disabled() {
            return view;
          },
        },
        remove_row: {
          disabled() {
            return view;
          },
        },
        cut: {
          disabled() {
            return view;
          },
        },
        copy: {
          disabled() {
            return view;
          },
        },
        undo: {
          disabled() {
            return view;
          },
        },
        freeze_column: {
          name: "Freeze Column",
          disabled() {
            return !view;
          },
        },
        unfreeze_column: {
          name: "Unfreeze Column",
          disabled() {
            return !view;
          },
        },
        export_to_csv_cpt: {
          name: "Export to CSV (CPT-wise)",
          callback(key, selection, clickEvent) {
            /**
              const columnOrderProvided = [
              'file_id',
              'encounter',
              'rendering',
              'enc dt',
              'cpt',
              'modifier',
              'units',
              'ICDs',
              'Notes',
              'Response',
              'Provider Education',
              'Number & complexity',
              'Amount and complexity',
              'Mortality of Patient Management'
            ];
            */
            const hot = hotRef.current.hotInstance;
    
            // Helper to escape CSV fields
            const escapeCsvField = (field) => {
                if (field === null || field === undefined) {
                    return '';
                }
                const stringField = String(field);
                if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\r\n')) {
                    const escapedField = stringField.replace(/"/g, '""');
                    return `"${escapedField}"`;
                }
                return stringField;
            };
    
            const sourceData = hot.getSourceData();
            
            const OMITTING_KEYS = [
              'missing_info',
              'provider_rvu',
              'provider_dollar_value',
              'agree',
              'disagree',
              'audited_rvu',
              'audited_dollar_value',
              'icd_agree',
              'icd_disagree'
            ]

            // these are the keys that needs to be separated, CPT(with units) and Modifier
            const FLATTENING_KEYS = [
              'srvcs_no',
              'audited_cpt',
              'billed_modifier',
              'audited_modifier'
            ]
            

            const columnOrder = columnData.map(c => c.data);
            let omittingIndices =[], firstFlatteningIndex = -1;
            // these are the keys before the cpt
            const STARTING_KEYS = [
              'file_name',
              'encounter_no',
              'rendering',
              'enc_dt'
            ]
            
            let last_audited_icd = -1;
            columnOrder.forEach((val, idx) => {
              if (OMITTING_KEYS.includes(val)) {
                omittingIndices.push(idx);
                return;
              }
              for (const prefix of FLATTENING_KEYS) {
                if (val.startsWith(prefix)) {
                  omittingIndices.push(idx);
                }
              }
            });


            let filteredColumnOrder = columnOrder.filter((_, idx) => !omittingIndices.includes(idx))
            let notes_pos = -1;
            filteredColumnOrder.forEach((val, idx) => {
              if (STARTING_KEYS.includes(val)) {
                firstFlatteningIndex = idx;
              }
              if (val.startsWith("audited_icd")) {
                last_audited_icd = idx;
              }
              if (idx !== -1 && val === 'notes') {
                notes_pos = idx;
              }
            })

            firstFlatteningIndex += 1;
            
            if (last_audited_icd != -1 && notes_pos !== -1) {
              // placing the notes after the last audited icd
              filteredColumnOrder.splice(last_audited_icd + 1, 0, "notes");
              // removing the notes key from it's original position
              filteredColumnOrder.splice(notes_pos, 1);
            }
            
            const headers = (localHeader && localHeader.length > 0) ? localHeader : auditSheetHeaders;
            let filteredCSVHeaders = headers.filter((_, idx) => !omittingIndices.includes(idx));

            if(last_audited_icd != -1 && notes_pos !== -1) {
              // placing the Notes header after the last audited icd
              filteredCSVHeaders.splice(last_audited_icd + 1, 0, "Notes");
              // removing the old notes position in the header list
              filteredCSVHeaders.splice(notes_pos, 1);
            }
            
            const FLATTENED_CSV_HEADERS = ["Billed CPT", "Audited CPT", "Billed Modifier", "Audited Modifier", "Units Billed", "Units Reviewed"];

            filteredCSVHeaders.splice(firstFlatteningIndex, 0, ...FLATTENED_CSV_HEADERS)

            const processedData = sourceData.map(row => {
                const newRow = { ...row };
                if (newRow.id === null) {
                    return null; 
                }

                const responseValue = newRow.response;
                if (responseValue) {
                    const availableOptions = generateOptions(row, responseAuditIssues);
                    const selectedIds = String(responseValue).split(',');
                    const displayNames = selectedIds.map(id => {
                        const option = availableOptions.find(opt => String(opt.id) === String(id));
                        return option ? option.name : id;
                    });
                    newRow.response = displayNames.join(', ');
                    if (newRow.response === "-1") {
                      newRow.response = "Agree Audits";
                    }
                }
                return newRow;
            }).filter(Boolean); 
            
            

            
            const csvHeader = filteredCSVHeaders.map(escapeCsvField).join(',');

            const csvRows = processedData.map(row => {
              if (typeof(row) !== 'object' || row === null) {
                return '';
              }

              const createCptDict = (key, keyPrefix, dict) => {
                if (!key.startsWith(keyPrefix)) {
                  return false;
                }
                const keySplits = key.split("_")
                const cptId = parseInt(keySplits.length === 3 ? keySplits[2] : "1", 10);
                dict[cptId] = row[key];
                return true;
              }

              let flatteningKeyValue = Array.from({ length: FLATTENING_KEYS.length }, (_, i) => ({}));

              Object.keys(row).forEach(key => {
                for (const [idx, prefix] of FLATTENING_KEYS.entries()) {
                  if (createCptDict(key, prefix, flatteningKeyValue[idx])) {
                    break;
                  }
                }
                
              });

              // 
              const getCptUnits = code => {
                if (!code) {
                  return [undefined, undefined];
                }
                const cptSplits = code.split("*");
                return cptSplits.length > 1 ? [cptSplits[0], cptSplits[1]] : [cptSplits[0], 1];
              }

              const maxCPTs = Math.max(...Object.keys(flatteningKeyValue[0]), ...Object.keys(flatteningKeyValue[1]));
              let flatteningValueList = [];
              for (let idx = 1; idx <= maxCPTs; idx++) {
                if (!flatteningKeyValue[0][idx] && !flatteningKeyValue[1][idx]) {
                  continue;
                }
                
                // pushing a list of ["Billed CPT", "Audited CPT", "Billed Modifier", "Audited Modifier", "Units Billed", "Units Reviewed"]
                let units_list = []
                flatteningValueList.push(FLATTENING_KEYS.map((_, i) => {
                  if (i === 0 || i == 1) {
                    const ret = getCptUnits(flatteningKeyValue[i][idx]);
                    units_list.push(ret[1]);
                    return ret[0];
                   }
                   let ret_list = [flatteningKeyValue[i][idx]];
                   if (i === 3) {
                    ret_list.push(...units_list)
                   }
                  return ret_list
              }).flat().map(escapeCsvField))
              }

              // parse the notes
              let commonNotes = "";
              let CPTtoNotesMap = {}


              flatteningValueList.forEach(el => {
                if (el[0]) {
                  CPTtoNotesMap[el[0]] = "";
                }
              });
              const NOTES_DELIMETERS = ['.', ';']
              if (row.notes) {
                for (const note of row.notes.split(new RegExp(`[${NOTES_DELIMETERS.join('')}]`))) {
                  if (!note) {
                    continue;
                  }
                  const tokens = note.split(" ");
                  let matchedCPTs = new Set();
                  for (const token of tokens) {
                    if (token in CPTtoNotesMap) {
                      matchedCPTs.add(token);
                    }
                  }

                  for (const cpt of matchedCPTs) {
                    CPTtoNotesMap[cpt] += `${note}. `;
                  }
                  if (!matchedCPTs.size) {
                    commonNotes += `${note}. `;
                  }
                }
              }
              
              // note parsing ends

              let result = [];

              for (const flattenedItem of flatteningValueList) {
                result.push(filteredColumnOrder.map((key, idx) => {
                  let flatteningPrefix = [];
                  if (idx === firstFlatteningIndex) {
                    flatteningPrefix = flattenedItem;
                  }
                  let ret; 
                  if (key === "enc_dt") {
                    ret = `="${escapeCsvField(row['enc_dt'])}"`;
                  }
                  else if (key === "notes") {
                    if (flattenedItem[0]) {
                      ret = escapeCsvField(CPTtoNotesMap[flattenedItem[0]] + commonNotes);
                    } else {
                      ret = escapeCsvField(commonNotes);
                    }
                  }
                  else {
                    ret = escapeCsvField(row[key]);
                  }
                  return [...flatteningPrefix, ret];
                }).flat().join(','))
              }
               
              return result;
            }).flat();
    
            const csvString = [csvHeader, ...csvRows].join('\r\n');
    
            const blob = new Blob([`\uFEFF${csvString}`], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            if (link.download !== undefined) { 
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', `audit_export.csv`);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
          },
        },
        export_to_csv: {
          name: "Export to CSV",
          callback(key, selection, clickEvent) {
            const hot = hotRef.current.hotInstance;
    
            // Helper to escape CSV fields
            const escapeCsvField = (field) => {
                if (field === null || field === undefined) {
                    return '';
                }
                const stringField = String(field);
                if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\r\n')) {
                    const escapedField = stringField.replace(/"/g, '""');
                    return `"${escapedField}"`;
                }
                return stringField;
            };
    
            const sourceData = hot.getSourceData();
            const headers = (localHeader && localHeader.length > 0) ? localHeader : auditSheetHeaders;
            const columnOrder = columnData.map(c => c.data);
    
            const processedData = sourceData.map(row => {
                const newRow = { ...row };
                if (newRow.id === null) {
                    return null; 
                }
                const responseValue = newRow.response;
                if (responseValue) {
                    const availableOptions = generateOptions(row, responseAuditIssues);
                    const selectedIds = String(responseValue).split(',');
                    const displayNames = selectedIds.map(id => {
                        const option = availableOptions.find(opt => String(opt.id) === String(id));
                        return option ? option.name : id;
                    });
                    newRow.response = displayNames.join(', ');
                }
                return newRow;
            }).filter(Boolean); 
    
            const csvHeader = headers.map(escapeCsvField).join(',');
            const csvRows = processedData.map(row => {
                return columnOrder.map(key => {
                    const value = (typeof row === 'object' && row !== null) ? row[key] : '';
                    return escapeCsvField(value);
                }).join(',');
            });
    
            const csvString = [csvHeader, ...csvRows].join('\r\n');
    
            const blob = new Blob([`\uFEFF${csvString}`], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            if (link.download !== undefined) { 
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', `audit_export.csv`);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
           
          },
        },
        rebuttals: {
          name: 'Add Rebuttal',
          hidden() {
            const [startRow, , endRow] = this.getSelectedLast();
            return startRow !== endRow || !sheetData[startRow]?.id;
          },
        },
      },
    },
    beforeChange: onBeforeHotChange,

    className: 'headerContainer',

    beforeKeyDown: function (e) {
      let col = this.getSelectedLast()[1];
      var evt = e || window.event; // IE support
      var key = evt.charCode || evt.keyCode || 0;

      // check for cut and paste
      var isClipboard = false;
      var ctrlDown = evt.ctrlKey || evt.metaKey; // Mac support

      // Check for Alt+Gr (http://en.wikipedia.org/wiki/AltGr_key)
      if (ctrlDown && evt.altKey) isClipboard = false;
      // Check for ctrl+c, v and x
      else if (ctrlDown && key === 67) isClipboard = true; // c
      else if (ctrlDown && key === 86) isClipboard = true; // v
      else if (ctrlDown && key === 88) isClipboard = true; // x
      else if (ctrlDown && evt.key === 'z') isClipboard = true; //z

      switch (col) {
        case 0:
        case 4:
        case 5:
        case 10:
        case 11:
          var isNumeric =
            NUMERIC_KEYS.includes(key) ||
            (key >= 35 && key <= 40) ||
            (key >= 48 && key <= 57) ||
            (key >= 96 && key <= 105);

          if ((!isNumeric && !isClipboard) || e.shiftKey) {
            // prevent alpha characters
            e.stopImmediatePropagation();
            e.preventDefault();
          }
          break;
        case 2:
          var number =
            NUMERIC_KEYS.includes(key) ||
            (key >= 35 && key <= 40) ||
            (key >= 48 && key <= 57) ||
            (key >= 96 && key <= 105);

          if ((!number && !isClipboard) || e.shiftKey) {
            // prevent alpha characters
            e.stopImmediatePropagation();
            e.preventDefault();
          }
          break;
        default:
          break;
      }
    },

    outsideClickDeselects: false,

    afterSelectionEnd: (row, col, row2, col2) => {
      if (onSelectionEnd) {
        onSelectionEnd(
          [{ start: { row, col }, end: { row: row2, col: col2 } }],
          sheetData[row]
        );
      }
    },

    afterOnCellMouseDown: (e, p) => {
      closeComment();
      if (p.col < 0) return; // row header click — ignore
      const rowId = sheetData[p.row]?.id;
      const canRebuttal = !!rowId && p.col !== 0;
      onCommentClick(
        [
          {
            start: { row: p.row, col: p.col },
            end: { row: p.row, col: p.col },
          },
        ],
        { pageX: e.clientX, pageY: e.clientY },
        false,
        canRebuttal,
        columnData,
        hotRef.current?.hotInstance.getSelected()[0]
      );
    },

    cells: function (row, col, prop) {
      var cellProperties = {};
      let COL = highlightedColumn; // [4, 5, 10, 11]
      if (batch) {
        COL = highlightedColumn; // [5, 6, 11, 12]
      }
      if (COL.includes(col)) {
        cellProperties.renderer = columnHighlight; // uses lookup map
      }
      if (highlightIndex === row) {
        cellProperties.renderer = rowHighlight;
      }
      // Check for missing_info and apply background color
      const rowData = this.instance.getSourceDataAtRow(row);
      if (rowData && rowData.missing_info) {
        cellProperties.className = 'missing-info';
      }

      // Row-wise rebuttal highlight
      const rowId = sheetData[row]?.id;
      if (rowId && commentFlags[rowId]?.['__row__'] !== undefined) {
        const base = cellProperties.className ? cellProperties.className + ' ' : '';
        cellProperties.className = base + (commentFlags[rowId]['__row__'] ? 'cq-row-rebuttal-open' : 'cq-row-rebuttal-resolved');
      }

      if(industryCodes){
        cellProperties.CPT = industryCodes;
      }
      if(iCDCodes){
        cellProperties.ICD = iCDCodes;
      }

      if(modifiers){
        cellProperties.Modifiers = modifiers;
      }

      return cellProperties;
    },
  };

  const batchColumnData = [
    {
      data: 'missing_info',
      type: 'checkbox',
      width: windowSize * 0.03,
      renderer: 'customStylesRendererCheckbox',
      readOnly: view,
    },
    {
      data: 'file_name',
      type: 'text',
      width: windowSize * 0.07,
      alignment: 'center',
      readOnly: true,
      renderer: 'customStylesRenderer',
    },
    {
      data: 'encounter_no',
      type: 'numeric',
      width: windowSize * 0.07,
      alignment: 'center',
      renderer: 'customStylesRenderer',
      readOnly: view,
    },
    {
      data: 'rendering',
      type: 'text',
      width: windowSize * 0.07,
      renderer: 'customStylesRenderer',
      readOnly: view,
    },
    {
      data: 'enc_dt',
      type: 'date',
      dateFormat: 'MM-DD-YYYY',
      width: windowSize * 0.07,
      renderer: 'customStylesRenderer',
      readOnly: view,
    },
    {
      data: 'srvcs_no',
      type: 'text',
      width: windowSize * 0.07,
      renderer: 'hoverCPTRenderer',
      readOnly: view,
    },
    {
      data: 'provider_rvu',
      type: 'numeric',
      width: windowSize * 0.07,
      renderer: 'customStylesRenderer',

      readOnly: view,
    },
    {
      data: 'provider_dollar_value',
      type: 'audit_sheet.currency_renderer',
      width: windowSize * 0.07,
      readOnly: view || isProviderDollarDisabled,
    },
    {
      data: 'response',
      type: 'text',
      width: windowSize * 0.15,
      renderer: 'customStylesRenderer',
      readOnly: view,
    },
    {
      data: 'agree',
      type: 'text',
      validator: agreeValidator,
      width: windowSize * 0.07,
      renderer: 'agreeRenderer',
      readOnly: view,
    },
    {
      data: 'disagree',
      type: 'text',
      validator: agreeValidator,
      width: windowSize * 0.07,
      renderer: 'agreeRenderer',
      readOnly: view,
    },
    {
      data: 'audited_code',
      type: 'text',
      width: windowSize * 0.07,
      renderer: 'hoverCPTRenderer',
      readOnly: view,
    },
    {
      data: 'audited_rvu',
      type: 'numeric',
      width: windowSize * 0.07,
      renderer: 'customStylesRenderer',

      readOnly: view,
    },
    {
      data: 'audited_dollar_value',
      width: windowSize * 0.07,
      type: 'audit_sheet.currency_renderer',
      readOnly: view || isAuditedDollarDisabled,
    },
    {
      data: 'notes',
      type: 'text',
      width: windowSize * 0.15,
      renderer: 'customStylesRenderer',
      readOnly: view,
    },
  ];
  
  const auditSheetColumnData = batch ? batchColumnData : _columnData;
  return (
    <HotTable
      ref={hotRef}
      columns={columnData} //auditSheetColumnData
      data={sheetData}
      settings={{
        ...hotSettings,
        rowHeights: getScaledRowHeight(scale),
        stretchH: 'all',
        autoColumnSize: false,
        autoRowSize: false,
        background: 'white',
        rowHeaders: true,
        manualColumnFreeze: true,
      }}
    ></HotTable>
  );
};
export default AuditSheet;
